import { RESET_MESSAGE_STORE, SHOW_MESSAGE } from './MessageType';

const initialState = {
  message: '',
  title: '',
  type: 'info',
  showMessage: false,
  messages: [],
  messageKeys: [],
};

export const MessageReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_MESSAGE_STORE: {
      state = initialState;
      return { ...state };
    }
    case SHOW_MESSAGE: {
      return { ...state, ...action.payload, showMessage: true };
    }

    default:
  }

  return state;
};

export default MessageReducer;
